import {
  Box,
  Button,
  Paper,
  Table,
  TextField,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const installement = [
  {
    sl: 1,
    corporateName: 'Axis Max Life Insurance Limited',
    policyNo: '4101241200000134-00',
    policyStartDate: '09 Dec 2024',
    policyEndDate: '08 Dec 2025',
    quotationPremium: '214766749.69',
    premiumReceived: '305828487.04',
    cdBalance: '12385925.50',
    dueDate: '09 Sep 2025',
    dueAmount: '53691687.44',
    collect: 'premium',
  },
  {
    sl: 1,
    corporateName: 'Axis Max Life Insurance Limited',
    policyNo: '4101241200000134-00',
    policyStartDate: '09 Dec 2024',
    policyEndDate: '08 Dec 2025',
    quotationPremium: '214766749.69',
    premiumReceived: '305828487.04',
    cdBalance: '12385925.50',
    dueDate: '09 Sep 2025',
    dueAmount: '53691687.44',
    collect: 'premium',
  },
  {
    sl: 1,
    corporateName: 'Cyient Limited',
    policyNo: '4101241200000180-00',
    policyStartDate: '01 Apr 2025',
    policyEndDate: '31 Mar 2026',
    quotationPremium: '164683897.50',
    premiumReceived: '274088075.64',
    cdBalance: '17684410.43',
    dueDate: '30 Sep 2025',
    dueAmount: '65873559.00',
    collect: 'premium',
  },
  {
    sl: 1,
    corporateName: 'Garware HI Tech Films Limited',
    policyNo: '4101241200000122-00',
    policyStartDate: '19 Dec 2024',
    policyEndDate: '08 Dec 2025',
    quotationPremium: '16524247.74',
    premiumReceived: '18800392.29',
    cdBalance: '609170.28',
    dueDate: '03 Sep 2025',
    dueAmount: '3304000.00',
    collect: 'premium',
  },
  {
    sl: 1,
    corporateName: 'Aquatech Systems(ASIA) Private Limited',
    policyNo: '4101241200000138-00',
    policyStartDate: '21 Jun 2025',
    policyEndDate: '20 Jun 2026',
    quotationPremium: '3075830.23',
    premiumReceived: '45479826.57',
    cdBalance: '104084.98',
    dueDate: '20 Sep 2025',
    dueAmount: '1230331.72',
    collect: 'premium',
  },
];

const InstallmentCollection = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [policyNo, setPolicyNo] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [filterType, setFilterType] = useState('');

  const handleFilter = () => {
    const filtered = installement.filter(row => {
      const policyDate = new Date(row.policyStartDate);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start && end) {
        return policyDate >= start && policyDate <= end;
      } else if (start) {
        return policyDate >= start;
      } else if (end) {
        return policyDate <= end;
      }
      return true;
    });

    setFilteredData(filtered);
  };

  useEffect(() => {
    // After data is fetched and setInstallement(installementData)
    setFilteredData(installement); // show all by default
  }, [installement]);
  return (
    <Box style={{ marginTop: '1rem' }}>
      <Box
        component={Paper}
        p={2}
        mb={2}
        fontWeight="bold"
        // sx={{
        //   border: '1px solid #1976d2',
        //   borderRadius: 1,
        // }}
      >
        Installment Collection
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={2} mt={2}>
        <Box display="flex" alignItems="flex-end" gap="2rem" style={{ display: 'flex', gap: '1rem' }}>
          {/* Filter Type Dropdown */}
          <Box sx={{ width: 220 }}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="filter-type-label">Search By</InputLabel>
              <Select
                labelId="filter-type-label"
                label="Filter By"
                value={filterType}
                onChange={e => setFilterType(e.target.value)}>
                <MenuItem value="">Select...</MenuItem>
                <MenuItem value="policy">Policy Number</MenuItem>
                <MenuItem value="date">Date Range</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Conditional Inputs */}
          {filterType === 'policy' && (
            <Box>
              <TextField
                label="Policy Number"
                size="small"
                value={policyNo}
                onChange={e => setPolicyNo(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          )}

          {filterType === 'date' && (
            <>
              <Box sx={{ minWidth: 160 }}>
                <TextField
                  label="Start Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
              <Box sx={{ minWidth: 160, ml: 3 /* ← Adds space between dates */ }}>
                <TextField
                  label="End Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </>
          )}

          {/* Search Button with extra margin on Date Range */}
          {filterType && (
            <Box sx={{ ml: filterType === 'date' ? 4 : 2 }}>
              <Button variant="contained" color="primary" onClick={handleFilter}>
                Search
              </Button>
            </Box>
          )}
        </Box>
      </Box>
      <Box style={{ marginTop: '1rem' }}>
        <TableContainer component={Paper}>
          <Table>
            {' '}
            <TableHead style={{ backgroundColor: '#f5f5f5' }}>
              <TableRow>
                <TableCell>Sl#</TableCell>
                <TableCell>Corporate Name</TableCell>
                <TableCell>Policy Number</TableCell>
                <TableCell>Policy Start Date</TableCell>
                <TableCell>Policy End Date</TableCell>
                <TableCell>Quotation Premium</TableCell>
                <TableCell>Premium Received</TableCell>
                <TableCell>CD Balance</TableCell>
                <TableCell colSpan={3} align="center">
                  Installment Details
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.corporateName}</TableCell>
                  <TableCell>{row.policyNo}</TableCell>
                  <TableCell>{row.policyStartDate}</TableCell>
                  <TableCell>{row.policyEndDate}</TableCell>
                  <TableCell>{row.quotationPremium}</TableCell>
                  <TableCell>{row.premiumReceived}</TableCell>
                  <TableCell>{row.cdBalance}</TableCell>

                  <TableCell>
                    <Box display="flex" flexDirection="column">
                      <Box fontSize={12} fontWeight="bold" color="gray">
                        Due Date
                      </Box>
                      <Box>{row.dueDate}</Box>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Box display="flex" flexDirection="column">
                      <Box fontSize={12} fontWeight="bold" color="gray">
                        Due Amount
                      </Box>
                      <Box>{Number(row.dueAmount).toLocaleString()}</Box>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Box display="flex" flexDirection="column" alignItems="center">
                      <Box fontSize={12} fontWeight="bold" color="gray">
                        Collect
                      </Box>
                      <Button variant="contained" size="small" color="primary" sx={{ mt: 0.5, textTransform: 'none' }}>
                        Premium
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default InstallmentCollection;
